import React, { ReactElement, ReactNode } from 'react';

import { Flex, FlexProps } from 'components/flex';

interface SectionProps extends FlexProps {
  children: ReactNode;
}

const Section = ({
  children,
  width = '100%',
  maxWidth = { m: '80%', t: 580, d: 1180 },
  minWidth = 320,
  marginX = 'auto',
  ...props
}: SectionProps): ReactElement => {
  return (
    <Flex data-test width={width} maxWidth={maxWidth} marginX={marginX} minWidth={minWidth} {...props}>
      {children}
    </Flex>
  );
};

export default Section;
